import { ACTIONS } from "../../enums/actions";
import { genericAction } from "./actionFunctions";

export const getDashboardData = genericAction(ACTIONS.GET_DASHBOARD_DATA);
export const getDashboardDetailData = genericAction(ACTIONS.GET_DASHBOARD_DETAIL_DATA);
